import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Metadata\GetInitialMetadatas::getAll
* @see app/Http/Controllers/Metadata/GetInitialMetadatas.php
* @route '/api/metadata/all'
*/
export const getAll = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: getAll.url(options),
    method: 'get',
})

getAll.definition = {
    methods: ["get","head"],
    url: '/api/metadata/all',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Metadata\GetInitialMetadatas::getAll
* @see app/Http/Controllers/Metadata/GetInitialMetadatas.php
* @route '/api/metadata/all'
*/
getAll.url = (options?: RouteQueryOptions) => {
    return getAll.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Metadata\GetInitialMetadatas::getAll
* @see app/Http/Controllers/Metadata/GetInitialMetadatas.php
* @route '/api/metadata/all'
*/
getAll.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: getAll.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Metadata\GetInitialMetadatas::getAll
* @see app/Http/Controllers/Metadata/GetInitialMetadatas.php
* @route '/api/metadata/all'
*/
getAll.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: getAll.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Metadata\GetInitialMetadatas::refreshModel
* @see app/Http/Controllers/Metadata/GetInitialMetadatas.php
* @route '/api/metadata/refresh-model'
*/
export const refreshModel = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: refreshModel.url(options),
    method: 'get',
})

refreshModel.definition = {
    methods: ["get","head"],
    url: '/api/metadata/refresh-model',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Metadata\GetInitialMetadatas::refreshModel
* @see app/Http/Controllers/Metadata/GetInitialMetadatas.php
* @route '/api/metadata/refresh-model'
*/
refreshModel.url = (options?: RouteQueryOptions) => {
    return refreshModel.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Metadata\GetInitialMetadatas::refreshModel
* @see app/Http/Controllers/Metadata/GetInitialMetadatas.php
* @route '/api/metadata/refresh-model'
*/
refreshModel.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: refreshModel.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Metadata\GetInitialMetadatas::refreshModel
* @see app/Http/Controllers/Metadata/GetInitialMetadatas.php
* @route '/api/metadata/refresh-model'
*/
refreshModel.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: refreshModel.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Metadata\GetInitialMetadatas::refreshSettings
* @see app/Http/Controllers/Metadata/GetInitialMetadatas.php
* @route '/api/metadata/refresh-settings'
*/
export const refreshSettings = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: refreshSettings.url(options),
    method: 'get',
})

refreshSettings.definition = {
    methods: ["get","head"],
    url: '/api/metadata/refresh-settings',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Metadata\GetInitialMetadatas::refreshSettings
* @see app/Http/Controllers/Metadata/GetInitialMetadatas.php
* @route '/api/metadata/refresh-settings'
*/
refreshSettings.url = (options?: RouteQueryOptions) => {
    return refreshSettings.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Metadata\GetInitialMetadatas::refreshSettings
* @see app/Http/Controllers/Metadata/GetInitialMetadatas.php
* @route '/api/metadata/refresh-settings'
*/
refreshSettings.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: refreshSettings.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Metadata\GetInitialMetadatas::refreshSettings
* @see app/Http/Controllers/Metadata/GetInitialMetadatas.php
* @route '/api/metadata/refresh-settings'
*/
refreshSettings.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: refreshSettings.url(options),
    method: 'head',
})

const GetInitialMetadatas = { getAll, refreshModel, refreshSettings }

export default GetInitialMetadatas